<template>
  <div class="mb-12 mt-12 pt-2">
    <v-dialog
      v-model="dialog.overview"
      persistent
      width="650">
      <v-card class="pa-5">
        <video
          id="myVideo"
          width="100%" 
          height="400px" 
          :src="detail.classesUrlOverview" 
          :poster="detail.classesUrlCover" 
          playsinline 
          controls>
        </video>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            rounded
            width="150"
            color="#3a3a3a"
            elevation="0"
            class="white--text text-capitalize mt-5 mb-0"
            @click="dialog.overview = false; stop()">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog.desc"
      persistent
      width="650">
      <v-card class="pa-5">
        <v-card-title class="subtitle-1 mb-1">
          {{ detail.classesTitle }}
        </v-card-title>
        <v-card-subtitle class="caption">
          Oleh {{ detail.classesUserName }}
        </v-card-subtitle>
        <v-card-text v-html="detail.classesDesc">
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            rounded
            width="150"
            color="#3a3a3a"
            elevation="0"
            class="white--text text-capitalize mt-5 mb-0"
            @click="dialog.desc = false">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog.public"
      persistent
      width="350">
      <v-card class="pa-5">
        <v-card-subtitle class="body-2" v-if="invoice.invoiceStatus === 'pending'">
          Untuk Melakukan Aksi ini, silahkan selesaikan pembelian kelas terlebih dahulu
        </v-card-subtitle>
        <v-card-subtitle class="body-2" v-if="invoice.invoiceStatus === 'confirmed'">
          Untuk Melakukan Aksi ini, harap menunggu konfirmasi kelas terlebih dahulu
        </v-card-subtitle>
        <v-card-subtitle class="body-2" v-if="invoice.cartStatus === 'pending'">
          Untuk Melakukan Aksi ini, silahkan mencheckout terlebih dahulu
        </v-card-subtitle>
        <v-card-subtitle class="body-2" v-if="invoice.cartStatus === ''">
          Untuk Melakukan Aksi ini, silahkan membeli kelas terlebih dahulu
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            rounded
            width="150"
            color="#3a3a3a"
            elevation="0"
            class="white--text text-capitalize mt-5 mb-0"
            @click="dialog.public = false">
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog 
      v-model="dialog.fileMateri" 
      persistent
      width="650">
      <v-card class="pa-5">
        <div class="headline font-weight-bold">
          {{ materiSelected.silabusMateriTitle }}
        </div>
        <video
          id="myVideoSilabus"
          width="100%" 
          height="400px" 
          :src="materiSelected.silabusMateriUrlFile" 
          :poster="materiSelected.silabusMateriUrlCover" 
          playsinline 
          controls>
        </video>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            rounded
            width="150"
            color="#3a3a3a"
            elevation="0"
            class="white--text text-capitalize mt-5 mb-0"
            @click="dialog.fileMateri = false; stopSilabus()">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      persistent
      v-model="dialog.login"
      max-width="375">
      <v-card class="pa-8"
        min-height="100%">
        <div class="text-center">
          <img :src="require('../../../../assets/logo/logo-1.png')">
          <div class="d-flex align-center mb-3">
            <v-divider></v-divider>
            <div class="mx-1 c-default font-weight-bold">
              <span>
                LOGIN
              </span>
            </div>
            <v-divider></v-divider>
          </div>
        </div>
        <ValidationObserver ref="observer">
          <v-form>
            <ValidationProvider name="Username" rules="required" v-slot="{ errors }">
              <v-text-field
                v-on:keyup.enter="toLogin"
                filled
                rounded
                dense 
                color="#f0932b"
                placeholder="Username"
                v-model="formLogin.username" 
                :error-messages="errors"
                required>
              </v-text-field>
            </ValidationProvider>
            <ValidationProvider name="Password" rules="required|min:8|max:20" v-slot="{ errors }">
              <v-text-field
                v-on:keyup.enter="toLogin"
                class="mt-2 mb-1" 
                filled
                rounded
                color="#f0932b"
                dense 
                placeholder="Password"
                v-model="formLogin.password" 
                :type="show ? 'text' : 'password'"
                :counter="20"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show = !show"
                :error-messages="errors"
                required>
              </v-text-field>
            </ValidationProvider>
          </v-form>
        </ValidationObserver>
        <v-alert 
          type="error" 
          text
          dense
          prominent
          v-show="response !== ''">
          {{ response }}
        </v-alert>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            :width="$vuetify.breakpoint.name === 'xs' ? '50%' : '150'"
            elevation="0"
            color="#3a3a3a"
            :disabled="process.login"
            :loading="process.login"
            class="white--text text-capitalize" 
            @click="toLogin">
            <b>Masuk</b>
          </v-btn>
          <v-btn
            rounded
            small
            elevation="0"
            :width="$vuetify.breakpoint.name === 'xs' ? '50%' : '150'"
            :disabled="process.login"
            @click.stop="dialog.login = false"
            @click="response = ''; dialog.login = false; formLogin.username = ''; formLogin.password = ''"
            class="text-capitalize font-weight-bold">
            <b>Batal</b>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog.cart"
      persistent
      width="450">
      <v-card class="pa-5">
        <v-card-subtitle class="body-2">
          Anda yakin untuk membeli kelas {{ detail.classesTitle }} ini ?
        </v-card-subtitle>
        <v-alert 
          type="error" 
          text
          dense
          prominent
          v-show="response !== ''">
          {{ response }}
        </v-alert>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            elevation="0"
            width="120"
            color="#3a3a3a"
            :disabled="process.cart"
            :loading="process.cart"
            class="white--text text-capitalize" 
            @click="createsCart">
            <b>Yakin</b>
          </v-btn>
          <v-btn
            rounded
            small
            width="120"
            elevation="0"
            class="text-capitalize"
            :disabled="process.cart"
            @click.stop="dialog.cart = false"
            @click="response = ''">
            <b>Batal</b>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog 
      v-model="dialog.rating" 
      persistent 
      max-width="450">
      <v-card class="px-5 py-2">
        <v-list
          color="transparent"
          dense
          subheader
          nav
          avatar
          class="pa-0">
          <v-list-item>
            <v-list-item-avatar tile width="20" height="auto" class="align-self-start justify-start mr-0">
              <v-icon>mdi-account</v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="py-1">
              <v-list-item-subtitle class="caption">
                {{ user.userName }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-avatar tile width="20" height="auto" class="align-self-start justify-start mr-0">
              <v-icon>mdi-email</v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="py-1">
              <v-list-item-subtitle class="caption">
                {{ user.userEmail }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-rating
          v-model="form.rating"
          color="#3a3a3a"
          background-color="grey darken-1"
          empty-icon="$ratingFull"
          class="mb-2">
        </v-rating>
        <ValidationObserver ref="observer">
          <ValidationProvider name="Deskripsi..." rules="required" v-slot="{ errors }">
            <v-textarea
              label="Deskripsi..."
              color="#F0932B"
              auto-grow
              outlined
              rows="4"
              row-height="30"
              :error-messages="errors"
              required
              v-model="form.reviewDescription">
            </v-textarea>
          </ValidationProvider>
        </ValidationObserver>
        <v-alert 
          type="error" 
          text
          dense
          prominent
          v-show="response !== ''">
          {{ response }}
        </v-alert>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            small
            rounded
            width="70"
            color="#3a3a3a"
            elevation="0"
            :disabled="process.rate"
            :loading="process.rate"
            class="white--text text-capitalize"
            @click="updatesReview">
            Kirim
          </v-btn>
          <v-btn
            rounded
            small
            width="70"
            elevation="0"
            class="text-capitalize mx-2"
            :disabled="process.rate"
            @click="dialog.rating = false">
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-breadcrumbs 
      :items="breadcrumbs" 
      divider=">"
      class="pa-1 px-5">
    </v-breadcrumbs>
    <v-row justify="center" v-if="process.run">
      <v-col :cols="$vuetify.breakpoint.name === 'xs' ? '6' : '3' ">
        <div
          class="text-center" 
          style="padding-top: 12rem; padding-bottom: 12rem; height:535px;">
          <p class="title mt-8 mb-5">
            Menunggu data . . .
          </p>
          <v-progress-linear
            color="black"
            indeterminate
            rounded
            height="6">
          </v-progress-linear>
        </div>
      </v-col>
    </v-row>
    <div v-if="!process.run">
      <div 
        class="background-class-detail" 
        :class="$vuetify.breakpoint.name === 'xs' ? 'px-0' : ''">
        <v-row class="px-8">
          <v-col cols="12" sm="8" class="white--text pt-5 pb-7">
            <div class="text-h4 font-weight-bold mb-1">
              {{ detail.classesTitle }}
            </div>
            <div class="body-1 mb-5">
              Dibuat oleh {{ detail.classesUserName }}
            </div>
            <div class="body-2 d-flex align-center mb-5">
              <v-icon dark small class="mr-1">mdi-shape</v-icon>
              <div class="pt-1">
                {{ detail.classesCategoryTitle }}  
              </div>
              <v-icon dark small class="ml-3 mr-1">mdi-library</v-icon>
              <div class="pt-1" v-if="detail.classesSilabus">
                {{ detail.classesSilabus.length }} Silabus  
              </div>
              <v-icon dark small class="ml-3 mr-1">mdi-file-video</v-icon>
              <div class="pt-1">
                {{ totalVideo }} video pembelajaran
              </div>
            </div>
            <div class="body-2 font-weight-bold mb-1">
              Tanggal pembuatan {{ detail.classesDateCreated | datetime }}
            </div>
            <div class="caption" v-if="detail.classesJoin">
              Pengguna terdaftar {{ detail.classesJoin.length }} orang
            </div>
          </v-col>
          <v-col cols="12" sm="4">
          </v-col>
        </v-row>
      </div>
      <v-row class="px-8">
        <v-col cols="12" sm="8" class="py-5 ">
          <div class="title font-weight-bold mb-2">
            Deskripsi
          </div>
          <div v-if="detail.classesDesc">
            <div v-if="detail.classesDesc.length > 1200">
              <div class="body-2"
                v-if="!showDesc">
                <span v-html="descShort"></span>
                <div class="font-weight-bold text--secondary caption c-p" @click="showDesc = true">
                  lihat selengkapnya
                  <v-icon small>mdi-chevron-down</v-icon>
                </div>
              </div>
              <div 
                class="body-2"
                v-if="showDesc">
                <span v-html="detail.classesDesc"></span>
                <div class="font-weight-bold text--secondary caption c-p" @click="showDesc = false">
                  tutup
                  <v-icon small>mdi-chevron-up</v-icon>
                </div>
              </div>
            </div>
            <div 
              class="my-5" 
              v-html="detail.classesDesc" v-if="detail.classesDesc.length <= 1200">
            </div>
          </div>
          <div class="d-flex font-weight-bold text--secondary title font-weight-bold align-center mb-3 mt-6">
            <div>
              Silabus
            </div>
          </div>
          <v-skeleton-loader
            class="ma-auto"
            :loading="process.silabus"
            transition="scale-transition"
            type="list-item-two-line"
            v-for="(l, index) in process.silabus ? 10:silabus"
            :key="index">
            <v-expansion-panels multiple accordion>
              <v-expansion-panel
                class="border-silabus"
                :class="{
                  'border-silabus-bottom' : index === silabus.length - 1
                }"
                v-if="silabus.length > 0">
                <v-expansion-panel-header>
                  {{ l.silabusTitle }}
                  <template v-slot:actions>
                    <v-icon color="#3a3a3a">$expand</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="text--secondary  body-2" v-html="l.silabusDesc"></div>
                  <div v-if="l.silabusMateri">
                    <div class="d-flex text--secondary body-2 font-weight-bold align-center mb-3 mt-5">
                      <div>
                        Materi
                      </div>
                    </div>
                    <v-list dense class="my-3" v-if="l.silabusMateri.length > 0">
                      <v-list-item
                        v-for="(materi, index) in l.silabusMateri" :key="index"
                        @click="!token ? dialog.login = true : changeMateriSelected(materi)"
                        v-on:click="token ?  invoice.invoiceStatus !== 'ok' ? dialog.public = true : dialog.fileMateri = true : ''">
                        <v-list-item-avatar tile class="c-p" style="box-shadow: 0px 5px 10px -5px rgba(0, 0, 0, 0.3) !important;">
                          <img :src="materi.silabusMateriUrlCover" style="border-radius: 5px;">
                        </v-list-item-avatar>
                        <v-list-item-content class="c-p">
                          <v-list-item-title class="body-2 font-weight-bold grey--text text--darken-2">
                            {{ materi.silabusMateriTitle }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="caption mt-1 font-weight-thin">
                            Judul Materi
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <Empty v-show="l.silabusMateri.length < 1"/>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-skeleton-loader>
          <div v-if="selabusPagination.totalPage > 1" class="mt-3">
            <v-row>
              <v-col cols="5">
                <div class="body-2	font-weight-bold mt-4">
                  Total {{ selabusPagination.totalData }} data
                </div>
              </v-col>
              <v-col cols="7">
                <div class="float-right">
                  <v-pagination
                    v-model="pageSilabus"
                    :length="selabusPagination.totalPage"
                    :total-visible="5"
                    color="#f0932b"
                    @input="fetchSilabus(pageSilabus)"
                    circle> 
                  </v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
          <Empty v-show="!process.silabus && silabus.length < 1"/>
          <div class="d-flex font-weight-bold text--secondary title align-center mt-10">
            <div>
              Diskusi 
            </div>
          </div>
          <div v-if="process.showForum">
            <v-list-item 
              class="my-2"
              v-for="(l, index) in 10"
              :key="index">
              <v-list-item-avatar
                color="#3a3a3a"
                size="100"
                tile
                style="border: 3px solid #3a3a3a; border-radius: 6px !important;">
                <v-skeleton-loader
                  ref="skeleton"
                  type="image"
                  class="mx-auto">
                </v-skeleton-loader>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-skeleton-loader
                  v-for="(item, i) in 2"
                  :key="i"
                  ref="skeleton"
                  type="paragraph"
                  class="mx-auto">
                </v-skeleton-loader>
              </v-list-item-content>
            </v-list-item>
          </div>
          <div v-if="!process.showForum">
            <v-list-item two-line class="px-0">
              <v-list-item-avatar
                color="#3a3a3a"
                size="80"
                tile
                class="align-self-start"
                style="border: 3px solid #3a3a3a; border-radius: 6px !important;">
                <v-img :src="user.userUrlImg" v-if="token"></v-img>
                <v-icon v-if="!token" x-large dark>mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-card
                  outlined
                  height="80"
                  style="overflow-y: auto;">
                  <quill-editor 
                    ref="myTextEditor" 
                    v-model="form.discussion" 
                    :options="option"
                    style="height: 100%">
                  </quill-editor>
                </v-card>
              </v-list-item-content>
            </v-list-item>
            <v-card-actions>
              <div class="flex-grow-1 align-center pl-2">
                <span v-show="error.discussion" class="caption red--text">
                  {{ error.discussion }}
                </span>
                <span v-show="responseParrent !== ''" class="caption red--text">
                  {{ responseParrent }}
                </span>
              </div>
              <v-btn
                rounded
                width="140"
                height="35"
                color="#3a3a3a"
                @click="!token ? dialog.login = true : invoice.invoiceStatus !== 'ok' ? dialog.public = true : createsForum('parrent')"
                :loading="process.forum"
                :disabled="process.forum"
                class="text-capitalize mt-1 font-weight-bold white--text">
                <b>Kirim</b>
              </v-btn>
            </v-card-actions>
            <v-divider class="my-4"></v-divider>
            <!-- <div v-if="token"> -->
              <div v-if="forum.length > 0">
                <v-list-item 
                  class="my-2"
                  v-for="(l, index) in forum"
                  :key="index">
                  <v-list-item-avatar
                    color="#3a3a3a"
                    :size="$vuetify.breakpoint.name === 'xs' ? 40 : 80"
                    tile
                    class="align-self-start"
                    style="border: 3px solid #3a3a3a; border-radius: 6px !important;">
                    <v-img :src="l.userDetail.userUrlImg"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-card
                      flat>
                      <div class="body-1">
                        {{ l.userDetail.userName }}
                        <span class="grey--text text--darken-2 mx-2 caption">{{ l.forumDatetime | datetime }}</span>
                      </div>
                      <div class="grey--text text--darken-1 mt-2 body-2" v-html="l.forumContent"></div>
                      <div class="grey--text text--darken-2 mx-1 caption">
                        <span @click="selectedReplay.ParrentId === l.id ? selectedReplay.ParrentId = '' : toSelectedForum('answer',l)" class="c-p">
                          <v-icon small>mdi-chat</v-icon> 
                          <span v-if="l.forumReplyDetail.length > 0"> {{ l.forumReplyDetail.length }} </span> Balas
                        </span>
                      </div>
                      <v-divider class="my-3" v-if="selectedReplay.ParrentId === l.id"></v-divider>
                      <div v-if="selectedReplay.ParrentId === l.id">
                        <div 
                          v-if="l.forumReplyDetail.length > 0" 
                          :class=" l.forumReplyDetail.length > 2 ? 'scrollReplay' : ''"
                          id="styleScroll">
                          <v-list-item 
                            class="my-2 scroll-child"
                            v-for="(replay, index) in l.forumReplyDetail"
                            :key="index">
                            <v-list-item-avatar
                              color="#3a3a3a"
                              :size="$vuetify.breakpoint.name === 'xs' ? 30 : 60"
                              tile
                              class="align-self-start"
                              style="border: 3px solid #3a3a3a; border-radius: 6px !important;">
                              <v-img :src="replay.userDetail.userUrlImg"></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-alert 
                                v-if="replay.forumReplyId !== null"
                                color="#ffca8e61"
                                dense
                                class="grey--text text--darken-1">
                                <div class="body-2 font-weight-bold">
                                  {{ replay.replyDetail.userDetail.userName }}
                                </div>
                                <div 
                                  class="mt-1 caption" 
                                  v-html="convert(replay.replyDetail.forumContent)">
                                </div>
                              </v-alert>
                              <v-card
                                flat>
                                <div class="body-1">
                                  {{ replay.userDetail.userName }}
                                  <span class="grey--text text--darken-2 mx-2 caption">{{ replay.forumDatetime | datetime }}</span>
                                </div>
                                <div class="grey--text text--darken-1 mt-2 body-2" v-html="replay.forumContent"></div>
                                <div 
                                  class="body-2 c-default c-p"
                                  @click="toSelectedForum('replay',replay); $vuetify.goTo(`#replay`)">
                                  Balas
                                </div>
                              </v-card>
                            </v-list-item-content>
                          </v-list-item>
                        </div>
                        <span id="replay"></span>
                        <v-alert 
                          v-if="selectedReplay.Name !== ''"
                          color="#f5f5f5"
                          dense>
                          <div class="d-flex body-2 grey--text text--darken-2">
                            <span class="font-weight-bold">{{ selectedReplay.Name }}</span>
                            <div class="text-right ml-auto">
                              <v-icon @click="selectedReplay.Name = ''; selectedReplay.ReplyId = '';  selectedReplay.Content = ''">mdi-close</v-icon>
                            </div>
                          </div>
                          <div class="mt-1 caption" v-html="selectedReplay.Content"></div>
                        </v-alert>
                        <v-flex
                          class="mt-2">
                          <v-row class="align-start">
                            <v-col 
                              class="pt-0 pb-0 "
                              cols="12"
                              sm="10">
                              <v-card outlined>
                                <v-row>
                                  <v-col 
                                    class="pt-0 pb-0">
                                    <quill-editor 
                                      ref="myTextEditor" 
                                      v-model="form.replayDiscussion"
                                      :options="optionSubDiscus">
                                    </quill-editor>
                                  </v-col>
                                </v-row>
                              </v-card>
                              <span v-show="error.replayDiscussion" class="caption red--text pt-3">
                                {{ error.replayDiscussion }}
                              </span>
                              <span v-show="responseChild !== ''" class="caption red--text">
                                {{ responseChild }}
                              </span>
                            </v-col>
                            <v-col 
                              class="pt-0 pb-0"
                              cols="12"
                              sm="2"
                              :class="$vuetify.breakpoint.name === 'xs' ? 'mt-2 text-right' : ''">
                              <v-btn
                                rounded
                                small
                                :block="$vuetify.breakpoint.name === 'xs' ? false : true"
                                :height="$vuetify.breakpoint.name === 'xs' ? auto : '35'"
                                color="#3a3a3a"
                                class="text-capitalize mt-1 font-weight-bold white--text"
                                :disabled="process.replay"
                                :loading="process.replay"
                                @click="!token ? dialog.login = true : invoice.invoiceStatus !== 'ok' ? dialog.public = true : createsForum('child')">
                                <b>Kirim</b>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-flex>
                      </div>
                    </v-card>
                  </v-list-item-content>
                </v-list-item>
              </div>
              <Empty v-show="forum.length < 1"/>
            <!-- </div> -->
          </div>
          <div class="d-flex font-weight-bold text--secondary title align-center mt-10">
            <div>
              Ulasan 
            </div>
          </div>
          <div>
            <v-container>
              <v-row class="align-center" v-if="Object.keys(ratingGra).length > 0">
                <v-col 
                  cols="12" 
                  md="2" 
                  class="text-center px-0">
                  <div class="text-h2 font-weight-bold mb-1">
                    {{ ratingGra.average }}
                  </div>
                  <v-rating dense
                    v-model="ratingGra.average"
                    readonly
                    color="#3a3a3a"
                    background-color="grey darken-1"
                    empty-icon="$ratingFull"
                    half-increments>
                  </v-rating>
                  <div class="text-center mt-3">
                    <v-btn
                      rounded
                      small
                      width="140"
                      color="#F0932B"
                      :disabled="process.review"
                      class="text-capitalize mt-1 font-weight-bold white--text mb-3"
                      @click="!token ? dialog.login = true : invoice.invoiceStatus !== 'ok' ? dialog.public = true : dialog.rating = true">
                      <b>Ubah Ulasan</b>
                    </v-btn>
                  </div>
                </v-col>
                <v-col 
                  cols="12" 
                  md="10"
                  class="pt-0">
                  <div 
                    v-for="(item, index) in ratingGra.rating"
                    :key="index">
                    <div class="d-flex align-center c-p">
                      <div class="pt-1" 
                      :class="$vuetify.breakpoint.name !== 'xs' ? 'w-progress' : 'w-xs-pro'">
                        <v-progress-linear
                          :color="selectedRating == 'all' ? '#000' : selectedRating !== index ? 'grey' : '#000'"
                          height="15"
                          rounded
                          :value="item.value"
                          @click="selectedRating = index; filter.rate = 5 - index; fetchReview()">
                        </v-progress-linear>
                      </div>
                      <div 
                        class="mr-auto pl-2" 
                        @click="selectedRating = index ; filter.rate = 5 - index; fetchReview()">
                        <v-icon 
                          color="#3a3a3a" 
                          v-for="(s, index) in 5 - index" 
                          :key="index">
                          mdi-star
                        </v-icon>
                      </div>
                      <div 
                        class="ml-auto grey--text text--darken-1 body-1 pr-5 py-1 pt-2 d-flex align-center">
                        <span :class="selectedRating !== index ? 'pr-5' : ''">
                          {{ item.value }}%
                        </span>
                        <span v-if="selectedRating === index">
                          <v-icon 
                            small 
                            class="pl-1" 
                            @click="selectedRating = 'all'; filter.rate = ''; fetchReview()">
                            mdi-close
                          </v-icon>
                        </span>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-divider class="my-4" v-if="!process.review"></v-divider>
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.review"
                tile
                transition="scale-transition"
                type="list-item-avatar-two-line"
                v-for="(l, index) in process.review ? 10:review"
                :key="index">
                <v-list dense>
                  <v-list-item 
                    class="my-2"
                    v-if="review.length > 0">
                    <v-list-item-avatar
                      color="#3a3a3a"
                      size="100"
                      tile
                      class="align-self-start"
                      style="border: 3px solid #3a3a3a; border-radius: 6px !important;">
                      <v-img :src="l.userUrlImg"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content class="pt-1" v-if="l.userReview">
                      <v-card
                        flat
                        class="background-transparent">
                        <div class="body-1">
                          {{ l.userName }}
                        </div>
                        <div>
                          <v-icon
                            small 
                            color="#3a3a3a" 
                            v-for="(star, no) in l.userReview.reviewValue" 
                            :key="no">
                            mdi-star
                          </v-icon>
                        </div>
                        <div class="grey--text text--darken-1 mt-1 caption">{{ l.userReview.reviewDescription }}</div>
                      </v-card>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-skeleton-loader>
              <Empty v-show="!process.review && review.length < 1"/>
              <div class="text-center mt-5" 
                v-if="paginationReview.totalPage > 1">
                <v-pagination
                  v-model="pageReview"
                  :length="paginationReview.totalPage"
                  :total-visible="5"
                  color="#f0932b"
                  @input="fetchReview(pageReview)"
                  circle>
                </v-pagination>
              </div>
            </v-container>
          </div>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card color="#fff" class="pa-2 card-img">
            <v-img
              :src="detail.classesUrlCover"
              width="100%"
              :height="$vuetify.breakpoint.name === 'xs' ? '200' : '200'" 
              gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)"
              class="align-center text-center c-p"
              @click="dialog.overview = true">
              <p>
                <img
                  :src="require('../../../../assets/icon/play-round.png')">
              </p>
            </v-img>
            <div class="py-5 px-2">
              <div class="headline font-weight-bold" v-if="detail.classesDiscount > 0">
                {{
                  detail.classesPrice - ((detail.classesPrice / 100) * detail.classesDiscount) | price
                }}
                <sup>
                  <v-avatar color="red" size="28">
                    <small class="white--text caption font-weight-bold"> 
                      {{ detail.classesDiscount }}%
                    </small>
                  </v-avatar>
                </sup>
              </div>
              <div class="subtitle-2 font-weight-bold text--secondary" style="text-decoration: line-through;"
                v-if="detail.classesDiscount > 0">
                {{ detail.classesPrice | price }}
              </div>
              <div class="headline font-weight-bold" v-if="detail.classesDiscount < 1">
                <span v-if="detail.classesPrice > 0">
                  {{ detail.classesPrice | price }}
                </span>
                <span v-if="detail.classesPrice < 1">
                  Gratis
                </span>
              </div>
              <div class="mt-3">
                <v-btn
                  block
                  rounded
                  width="175"
                  color="#3a3a3a"
                  class="text-capitalize mt-1 white--text font-weight-bold"
                  :disabled="invoice.invoiceStatus === 'ok'"
                  @click="toAction">
                  <span v-if="!invoice.cart">Beli Kelas</span>
                  <span v-else>
                    <span v-if="invoice.cartStatus === 'pending'">Lihat Keranjang</span>
                    <span v-if="invoice.invoiceStatus === 'confirmed'">Mengunggu Konfirmasi</span>
                    <span v-if="invoice.invoiceStatus === 'pending'">Selesaikan Pembelian</span>
                    <span v-if="invoice.invoiceStatus === 'ok'">Terbeli</span>
                  </span>
                </v-btn>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <div class="v-add-position">
        <v-fab-transition>
          <v-btn 
            class="v-add"
            color="rgb(51, 51, 51)"
            rounded
            fixed
            bottom
            right
            fab
            @click="toTop"
            elevation="0">
            <v-icon color="white">mdi-chevron-up</v-icon>
          </v-btn>
        </v-fab-transition>
      </div>
    </div>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../../service/Axios";
  import Empty from "../../../../components/DataEmpty";
  export default {
    data () {
      return {
        breadcrumbs: [                                             
          {
            text: 'Kelas',
            disabled: false,
            href: '/marketplace/class',
          },
          {
            text: 'Detail Kelas',
            disabled: true,
            href: '/marketplace/class/id',
          }
        ],
        option: {
          theme: 'bubble',
          placeholder: 'Tulis komentar . . .'
        },
        optionSubDiscus: {
          theme: 'bubble',
          placeholder: 'Tulis balasan . . .'
        },
        dialog: {
          overview: false,
          desc: false,
          fileMateri: false,
          public: false,
          login: false,
          cart: false,
          rating: false
        },
        showDesc: false,
        descShort: '',
        silabusDescShort: '',
        totalVideo: 0,
        detail:{},
        invoice: {},
        forum: [],
        silabus: [],
        selabusPagination: {},
        pageSilabus: 1,
        silabusPage: '',
        materiSelected: {},
        rating: 4.5,
        ratingGra: {},
        selectedRating: 'all',
        review: [],
        paginationReview: {},
        pageReview: 1,
        filter: {
          rate: ''
        },
        selectedReplay: {
          ReplyId: '',
          ParrentId: '',
          Content: '',
          Name: ''
        },
        formLogin: {
          username: '',
          password: ''
        },
        form: {
          discussion: '',
          replayDiscussion: '',
          rating: 0,
          reviewDescription: ''
        },
        error: {
          discussion: '',
          replayDiscussion: ''
        },
        process: {
          run: false,
          silabus: false,
          forum: false,
          showForum: false,
          replay: false,
          login: false,
          cart: false,
          review: false,
          rate: false
        },
        response: '',
        responseParrent: '',
        responseChild: '',
      }
    },
    components: {
      Empty
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      token () {
        return this.$store.state.token
      }
    },
    mounted () {
      window.scrollTo(0, 0)
      this.fetch()
      this.fetchSilabus()
      this.fetchForum()
      this.fetchReview()
      if (this.token) {
        this.fetchInvoice()
      }
    },
    methods: { 
      async fetch() {
        this.process.run = true
        let url = !this.token ? `api/users/public/marketplace/detail/${this.$route.params.id}` : `api/users/marketplace/detail/${this.$route.params.id}`
        await get(`${url}`)
        .then((response) => {
          let res = response.data
          if (res.code === 200) {
            this.process.run = false
            this.detail = res.data
            this.detail.classesDesc = this.detail.classesDesc.replace(/&lt;/g, '<')

            if (this.detail.classesDesc.length > 350) {
              this.descShort = this.detail.classesDesc.substring(0, 350) + " . . ."
            } else {
              this.descShort = this.detail.classesDesc
            }

            let item = res.data.classesSilabus
            for (let i in item) {
              this.totalVideo += item[i].silabusMateri.length
            }
          }
        })
      },
      async fetchInvoice() {
        this.process.run = true
        await get(`api/users/cart/detail/status/${this.$route.params.id}`)
        .then((response) => {
          let res = response.data
          if (res.code === 200) {
            this.process.run = false
            this.invoice = res.data
          }
        })
      },
      async fetchSilabus(p) {
        this.process.silabus = true
        let url = !this.token ? `api/users/public/marketplace/silabus/${this.$route.params.id}` : `api/users/class/silabus/${this.$route.params.id}`
        await get(`${url}`, {
          params: {
            pagenum: p
          }
        })
        .then((response) => {
          if (response.data.code === 200) {
            this.silabus = response.data.data
            if (this.silabus.length > 0) {
              for (let i in response.data.data) {
                this.silabus[i].silabusDesc = response.data.data[i].silabusDesc.replace(/&lt;/g, '<')
              }
            }
            this.selabusPagination = response.data.pagination
            if (this.showAll === false) {
              this.silabusSelected = this.silabus[0]
            } 
            this.process.silabus = false
          }
        })
      },
      async fetchForum(status) {
        this.process.showForum = status === 'replay' ? false : true
        await get(`api/users/forum/list`, {
          params: {
            classId: this.$route.params.id,
            limit: 10000
          }
        })
        .then((response) => {
          let res = response.data
          if (res.code === 200) {
            this.forum = res.data
            if (this.forum.length > 0) {
              for (let i in response.data.data) {
                this.forum[i].forumContent = response.data.data[i].forumContent.replace(/&lt;/g, '<')
                for (let j in response.data.data[i].forumReplyDetail) {
                  this.forum[i].forumReplyDetail[j].forumContent = response.data.data[i].forumReplyDetail[j].forumContent.replace(/&lt;/g, '<')
                }
              }
            }
            this.process.showForum = false
            this.process.forum = false
            this.process.replay = false
          }
        })
      },
      async fetchReview(p) {
        this.process.review = true
        await get(`api/users/users/list/review`, {
          params: {
            pagenum: p,
            rate: this.filter.rate,
            classId: this.$route.params.id
          }
        })
        .then((response) => {
          let res = response.data
          if (res.code === 200) {
            for(let i in res.data){
              if (res.data[i].id === this.user.userId) {
                this.form.rating = res.data[i].userReview.reviewValue
                this.form.reviewDescription = res.data[i].userReview.reviewDescription
              }
            }
            this.ratingGra = res.rating
            this.ratingGra.average = parseFloat(this.ratingGra.average)
            this.review = res.data
            this.paginationReview = res.pagination
            this.process.review = false
          }
        })
      },
      convert(item) {
        return item.replace(/&lt;/g, '<')
      },
      toTop() {
        window.scrollTo({top: 0, behavior: 'smooth'})
      },
      toSelectedForum(status, item) {
        if (status === 'answer') {
          this.selectedReplay = {
            ReplyId: item.forumReplyId,
            ParrentId: item.id,
            Content: '',
            Name: ''
          }
        } else {
          this.selectedReplay = {
            ReplyId: item.id,
            ParrentId: item.forumParrentId,
            Content: item.forumContent,
            Name: item.userDetail.userName
          }
        }
        this.error= {
          discussion: '',
          replayDiscussion: ''
        }
      },
      changeMateriSelected(item) {
        this.materiSelected = item
      },
      stop() {
        let vid = document.getElementById("myVideo")
        vid.pause()
      },
      stopSilabus() {
        let vid = document.getElementById("myVideoSilabus")
        vid.pause()
      },
      toAction () {
        if (!this.token) {
           this.dialog.login = true
        } else {
          if (!this.invoice.cart) {
            this.dialog.cart = true
          } else {
            if (this.invoice.cartStatus === 'pending') {
              this.$router.push('/cart')
            } else if (this.invoice.invoiceStatus === 'pending') {
              const url = `/transaction`
              this.$router.push(url)
            } else if (this.invoice.invoiceStatus === 'confirmed') {
              this.$router.push('/transaction')
            } 
          }
        }
      },
      validation() {
        var error = this.error,
            valid = true
        
        if (this.form.discussion === '') {
          error.discussion = 'Kolom tidak boleh kosong'
          valid = false
        } else {
          error.discussion = ''
        }
        
        return valid;
      },
      validationReply() {
        var error = this.error,
            valid = true

        if (this.form.replayDiscussion === '') {
          error.replayDiscussion = 'Kolom tidak boleh kosong'
          valid = false
        } else {
          error.replayDiscussion = ''
        }
        
        return valid;
      },
      // toStopLoader(status) {
      //   if (status === 'parrent') {
      //     this.process.forum = false
      //     this.selectedReplay.ParrentId = ''
      //   } else {
      //     this.process.replay = false
      //   }
      // },
      async createsForum(status) {
        this.responseParrent = ''
        this.responseChild = ''
        this.error= {
          discussion: '',
          replayDiscussion: ''
        }
        if (status === 'parrent') {
          this.selectedReplay = {
            ReplyId: '',
            ParrentId: '',
            Content: '',
            Name: ''
          }
        }
        const valids = status === 'parrent' ? this.validation() : this.validationReply()
        if (valids) {
          if (status === 'parrent') {
            this.process.forum = true
          } else {
            this.process.replay = true
          }
          await post(`users/forum/create`, {
            data: {
              userId : this.user.userId,
              classId : this.$route.params.id,
              content : status === 'parrent' ? this.form.discussion : this.form.replayDiscussion,
              parrentId : status === 'parrent' ? '' : this.selectedReplay.ParrentId,
              replyId : status === 'parrent' ? '' : this.selectedReplay.ReplyId
            }
          })
          .then((response) => {
            let res = response.data
            if (res.code === 201) {
              this.form.discussion = '',
              this.form.replayDiscussion = ''
              this.selectedReplay.Content = ''
              this.selectedReplay.Name = ''
              this.selectedReplay.ReplyId = ''
              this.fetchForum('replay')
            } else {
              if (status === 'parrent') {
                this.process.forum = false
              } else {
                this.process.replay = false
              }
              if (status === 'parrent') {
                this.responseParrent = res.msg 
              } else {
                this.responseChild = res.msg 
              }
            }
          })
        }
      },
      async updatesReview() {
        this.response = ''
        if (this.form.rating === 0) {
          this.response = 'Harap untuk mengisi rating'
        }
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.rate = true
          await put(`api/users/users/update/review/${this.user.userId}`, {
            data: {
              review : {
                review_class_id : this.$route.params.id,
                review_description : this.form.reviewDescription,
                review_value : this.form.rating
              }
            }
          })
          .then((response) => {
            let res = response.data
            if (res.code === 201) {
              this.dialog.rating = false
              this.fetchReview()
              this.process.rate = false
            } else {
              this.process.rate = false
              this.response = res.msg 
            }
          })
        }
      },
      async toLogin() {
        this.response = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.login = true
          await post(`api/users/login`, {
            data: {
              email: this.formLogin.username,
              password : this.formLogin.password,
              device : "mobile"
            }
          })
          .then((response) => {
            let res = response.data
            if (res.code === 200) {
              TokenService.saveToken(res.data.token, JSON.stringify(res.data.user))
              window.location= `/marketplace/class/${this.$route.params.id}`
            } else {
              this.process.login = false
              this.response = res.msg
            }
          })
        }
      },
      async createsCart() {
        this.process.cart = true
        await post(`api/users/cart/create`, {
          data: {
            productId : this.$route.params.id,
	          productType : "class"
          }
        })
        .then((response) => {
          let res = response.data
          if (res.code === 201) {
            window.location= `/cart`
          } else {
            this.process.cart = false
            this.response = res.msg
          }
        })
      }
    }
  }
</script>

<style>
  .c-default {
    color: #ff618a !important;
  }
  .background-class-detail {
    background-color: #3a3a3a;
    /* background: url('../../../../assets/background/background-top.png'); */
    /* min-height: 100%; */
    /* background-repeat: no-repeat;
    background-size: cover; */
  }
  .card-img {
    width: 350px;
    margin-left: auto;
    margin-top: -200px;
  }
  .border-silabus {
    border-top: thin solid #ddd;
    border-left: thin solid #ddd;
    border-right: thin solid #ddd;
    border-radius: 0px;
  }
  .border-silabus-bottom {
    border-bottom: thin solid #ddd;
  }
  .v-expansion-panel:not(:first-child)::after {
    border-top: none !important;
  }
  .v-expansion-panel::before {
    box-shadow: none !important;
  }
  .d-grib {
    display: grid !important;
  }
  .active {
    font-weight: bold;
    color: #F0932B !important;
  }
  .line-detail {
    border-width: 1px;
    border-color: #F0932B;
    width: 15%;
  }
  .background-silabus-cols {
    background-color: #F5F5F5 !important;
    height: 100% !important;
    border-radius: 20px !important;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
  }
  .title-card {
    text-align: left;
    position: absolute;
    bottom: 5px;
    color: white;
  }
  .card-silabus-active {
    border-left: 6px solid #F0932B !important;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
    transition: .3s;
  }
  .v-card--link:before {
    background: #fff !important;
  }
  .scrollMateri {
    height: 220px; 
    overflow-y: scroll;
  }
  .scrollMateriInsert {
    height: 420px; 
    overflow-y: scroll;
  }
  .scrollReplay {
    height: 300px; 
    overflow-y: scroll;
  }
  /* #styleScroll::-webkit-scrollbar-track{
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: #F5F5F5;
    border-radius: 10px;
  }

  #styleScroll::-webkit-scrollbar{
    width: 5px;
    background-color: #F5F5F5;
  } */

  #styleScroll::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #F90; 
    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%,rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%,transparent 75%, transparent)
  }
  /* .w-progress{
    max-width:75%;
    min-width:67%;
  }
  .w-xs-pro{
    max-width: 48%;
    min-width: 30%;
  } */
</style>